import React, { DragEvent, useEffect, useState } from 'react'
import CouponConfigurableLabel from '../../../CouponConfigurableLabel';
import { Button, Chip } from '@mui/material';
import { convertFileToListOfData } from './service';
import Dropzone from '../Dropzone';
import { isExclusionEmpty, validateXLSXFileType, uploadExclusionFile } from '../service';
import { openPopup } from '../../../../../../stateManagement/actions/popupActions';
import { labelMappings } from '../../../../utils/utils';
import { resetExclusionData, updateExclusionData, saveExclusionFileUrl } from '../../../../../../stateManagement/actions/manageCouponActions';
import { useCouponAlert } from '../../../../context/CouponAlert';
import DoneIcon from '@mui/icons-material/Done';
import { useSelector } from 'react-redux';
import CouponLoader from '../../../CouponLoader';
import { isLargeExclusion } from '../../../../services/services';


/**
 * This component is responsible for getting excel file input for outlet code exculsion
 * @returns 
 */

function ExclusionList({ disable , disabledMessage }: { disable?: boolean , disabledMessage?:string }) {
    const [excData, setExcData] = useState<{ file: File | null, list: Array<string> }>({ file: null, list: [] });
    const { showAlert } = useCouponAlert();
    const {list:exclusionList , file:exclusionFile} = useSelector((state:any)=>state?.manageCoupons?.data?.exclusionData);
    const [isUploading, setIsUploading] = useState(false);
    const redux_exclusion_file_url = useSelector((state: any) => state?.manageCoupons?.data?.exclusionFileUrl);

    const handleFileInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (disable) {
            showAlert(disabledMessage ?? labelMappings['EXCLUSION_DISABLED'], 'warning');
            return;
        };

        const files = event?.target?.files;
        if (files && files[0]) {
            processFile(files[0]);
        }
    }
    const processFile = async (file: File) => {
        if (disable) {
            showAlert(disabledMessage ?? labelMappings['EXCLUSION_DISABLED'], 'warning');
            return;
        };
        const data: string[] = await convertFileToListOfData(file);
        setExcData({file:file , list:data});
    }

    const handleFileRemove = () => {
        setExcData({file:null , list:[]});
        if(!isExclusionEmpty()){
            resetExclusionData();
            saveExclusionFileUrl("");
        }
        setIsUploading(false);
    }

    const handleDrop = async (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();

        if (disable) {
            showAlert(disabledMessage ?? labelMappings['EXCLUSION_DISABLED'], 'warning');
            return;
        };

        const files = e?.dataTransfer.files;
        if (files && files[0]) {
            const res = await validateXLSXFileType(files[0]);
            if (res === false) {
                openPopup("Error", labelMappings["INVALID_FILE_INPUT"]);
                return;
            }
            processFile(files[0]);
        }
    }

    const handleSave = async () => {
    
        updateExclusionData(excData.list , excData.file);
        if(isLargeExclusion()) {
            try {
                setIsUploading(true);
                if(excData.file !== null){
                    const exclusionFileUrl = await uploadExclusionFile(excData.file);
                    saveExclusionFileUrl(exclusionFileUrl);
                    console.log("exclusionFileUrl: " + exclusionFileUrl);
                    showAlert("File uploaded", 'success');
                } 
            } catch (error) {
                showAlert("Failed to upload file", 'error');
            } finally {
                setIsUploading(false);
            }
        } else {
            showAlert("Data Saved", 'success');
        }
    }

    const checkUploadStatus = () => {
        return redux_exclusion_file_url === "" ? false : true;
    }

    useEffect(() => {
        if (disable)
            handleFileRemove()
    }, [disable])

    useEffect(()=>{
        if(exclusionList.length > 0){
            setExcData({list : exclusionList , file:exclusionFile});
        }
    },[exclusionList,exclusionFile])

    return (
        <div className='exclusion-list-wrapper'>
            {
                disable && <div
                    className="coupon-dashboard-disable-overlay"
                    onClick={() => showAlert(labelMappings['EXCLUSION_DISABLED'], 'info')} />
            }

            <div className="exclusion-list-header">
                <CouponConfigurableLabel text='EXCLUSION_LIST_HEADER' style={{ color: 'inherit' }} />
            </div>
            <div className="exclusion-list-content">
                <Dropzone handleDrop={handleDrop} handleFileRemove={handleFileRemove} file={excData.file} handleFileInput={handleFileInput} />
                {
                    excData.list && excData.list.length > 0 &&
                    <div className='exclusion-selected-outlet-code-wrapper'>
                        <div className='exclusion-selected-outlet-code'>
                            {isLargeExclusion() ? <></> :
                                <>
                                {
                                    excData.list.map((item: string) => {
                                        return <Chip label={item} key={`exlusion-${item}`} />
                                    })
                                }
                                </>
                            }
                            {/* {
                                excData.list.map((item: string) => {
                                    return <Chip label={item} key={`exlusion-${item}`} />
                                })
                            } */}
                        </div>
                        <div className='ex-in-save-btn-wrapper'>
                                {isLargeExclusion() ?
                                    <>
                                        {isUploading ? <CouponLoader /> :
                                            <Button variant='contained' className='inc-exc-save-btn' size='small' startIcon={<DoneIcon />} onClick={handleSave} disabled={checkUploadStatus()}>Save</Button>
                                        }
                                    </> :
                                    <>
                                    <Button variant='contained' className='inc-exc-save-btn' size='small' startIcon={<DoneIcon />} onClick={handleSave}>Save</Button> 
                                    </>
                                }
                        </div>
                    </div>
                }
            </div>

        </div>
    )
}

export default ExclusionList